type callbackFn<Item> = (items: Array<Item>) => void;

export default class Queue<Item> {
    private timer: number;

    private delay: number;

    private list: Array<Item>;

    private callback: callbackFn<Item>;

    constructor(delay: number, callback: callbackFn<Item>) {
        this.delay = delay;
        this.callback = callback;

        this.reset();
    }

    reset(): void {
        this.list = [];

        if (this.timer) {
            window.clearTimeout(this.timer);

            this.timer = null;
        }
    }

    push(item: Item): void {
        this.list.push(item);

        if (this.list.length === 1) {
            this.timer = window.setTimeout(() => {
                this.onTime();
            }, this.delay);
        }
    }

    onTime(): void {
        this.callback(this.list);

        this.reset();
    }
}
